var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"refDefaultBox",class:_vm.$style.videoBox},[_vm._t("default"),(_vm.defaultBox && !_vm.$slots.default)?_c('div',{class:_vm.$style.defaultBox},[_c('img',{class:_vm.$style.image,style:({
        width: ((_vm.image.width) + "px"),
        height: ((_vm.image.height) + "px"),
      }),attrs:{"src":require("@/assets/images/tishi.png")}}),_c('div',{class:_vm.$style.descInfo},[_c('p',{class:_vm.$style.info},[_vm._v("从右侧列表拖拽到此处")])])]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }